<template>
  <div class="w-100">
    <div v-if="title" class="atom-file-input__title">
      {{ title
      }}<label v-if="isAsterisk" class="atom-file-input__asterisk">*</label>
    </div>
    <div class="atom-file-input__container">
      <b-form-file
        v-model="file"
        class="atom-file-input__form"
        placeholder="Select File (Max. 25MB)"
        :disabled="isDisable"
        :state="stateError"
        :accept="isOnlyImage ? '.jpg, .jpeg, .png' : undefined"
      ></b-form-file>
    </div>
    <div v-if="isError && errorMessage" class="atom-file-input--error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { BFormFile } from "bootstrap-vue"
import AtomButton from "./AtomButton.vue"
export default {
  name: "AtomFileInput",
  components: { BFormFile, AtomButton },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isError: {
      type: Boolean,
      required: false,
      default: null,
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: File,
      required: false,
    },
    isOnlyImage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    file: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    stateError() {
      /**
       * ? Red border at input will show when state is "false", therefore if error return "false", otherwise return "null" (normal state)
       * ? Remarks: state "true" is Green border at input
       */
      return this.isError ? false : null
    },
  },
  methods: {
    selectFile() {},
  },
}
</script>

<style lang="scss" scoped>
.atom-file-input__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.atom-file-input__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.atom-file-input--error {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}
</style>
